import $ from 'jquery';

export default function allergenChecker() {
  const data = {
    'BIKTARVY': {
      'name': 'Biktarvy&reg;',
      'generic': '(bictegravir 50 mg, emtricitabine 200 mg, tenofovir alafenamide 25 mg tablets)',
    },

    'BIXLENVO': {
      'name': 'Bixlenvo&trade;',
      'generic': '(bictegravir 75mg/lenacapavir 50 mg tablets)',
    },

    'DESCOVY': {
      'name': 'Descovy&reg;',
      'generic': '(emtricitabine 200 mg and tenofovir alafenamide 25 mg tablets)',
    },

    'EPCLUSA': {
      'name': 'Epclusa&reg;',
      'generic': '(sofosbuvir 400 mg and velpatasvir 100 mg tablets)',
    },

    'LIVDELZI': {
      'name': 'Livdelzi&reg;',
      'generic': '(seladelpar 10 mg capsules)',
      'allergens': {
        'animal-derived products': 'Yes',
        'alcohol': '712 parts per million',
        'sorbitol': '0.74% (1.18mg)',
        'certified kosher': 'Yes',
        'certified halal': 'Yes',
      },
    },

    'SUNLENCA-TABLET': {
      'name': 'Sunlenca&reg;',
      'generic': '(lenacapavir 300 mg tablets)',
    },

    'SUNLENCA-INJECTION': {
      'name': 'Sunlenca&reg;',
      'generic': '(lenacapavir injection 463.5 mg per 1.5 mL)',
    },

    'TRODELVY': {
      'name': 'Trodelvy&reg;',
      'generic': '(sacituzumab govitecan-hziy 180 mg for injection)',
      'allergens': {
        'animal-derived products': 'from Sp2 mouse cells',
      },
    },

    'TRUVADA': {
      'name': 'Truvada&reg;',
      'generic': '(emtricitabine 200 mg and tenofovir disoproxil fumarate 300 mg tablets)',
      'allergens': {
        'animal-derived products': 'Yes',
        'lactose monohydrate': '80',
      },
    },

    'VEKLURY': {
      'name': 'Veklury&reg;',
      'generic': '(remdesivir 100 mg for injection)',
    },

    'VEMLIDY': {
      'name': 'Vemlidy&reg;',
      'generic': '(tenofovir alafenamide 25 mg tablets)',
      'allergens': {
        'animal-derived products': 'Yes',
        'lactose monohydrate': '95',
      },
    },
  };

  const $form = $('.js-allergen-checker-form');
  const $product = $('.js-allergen-checker-product');
  const $allergen = $('.js-allergen-checker-allergen');
  const $submitBtn = $('.js-allergen-checker-submit-btn');

  const $result = $('.js-allergen-checker-result');
  const $defaultText = $('.js-allergen-checker-default-text');
  const $response = $('.js-allergen-checker-response');

  const getSelectValue = (select) => {
    if ( !select || !select.length ) {
      console.error('Incorrect select');
      return;
    }

    return select.find(':selected').val();
  };

  const resetResult = () => {
    $result.hide();
    $defaultText.show();
    $response.html('');
  };

  $product.on('change', function () {
    const selectedProduct = getSelectValue($product);

    if (selectedProduct) {
      $allergen.prop('disabled', false);
    } else {
      $allergen.prop('disabled', true);
      $allergen.val(null).trigger('change');
    }
  });

  $form.on('change', () => {
    resetResult();
    $submitBtn.removeClass('is-disabled');
  });

  $submitBtn.on('click', function (e) {
    e.preventDefault();

    if ( !$form.valid() ) {
      return false;
    }

    $submitBtn.addClass('is-disabled');

    const productValue = getSelectValue($product);
    const allergenRawValue = getSelectValue($allergen);
    const allergenValue = allergenRawValue.toLowerCase();

    const productName = data[productValue].name;
    const productNameWithoutReg = productName.replace(/&reg;|®|&trade;|™/gi, '').trim();
    // const productGeneric = data[productValue].generic;
    // const productFullName = productName + ' ' + productGeneric;
    const allergenResponse = data[productValue] && data[productValue].allergens && data[productValue].allergens[allergenValue];

    $defaultText.hide();
    $result.show();

    if ( allergenValue === 'lactose monohydrate' ) {
      if ( allergenResponse ) {
        $response.html(`
          <p>
            <b>${productNameWithoutReg}</b> does contain <b>${allergenResponse}</b>&nbsp;mg per unit <b>${allergenValue}</b>, which is dairy-derived and certified halal and kosher. Please note that ${productNameWithoutReg} is NOT certified halal and kosher.
          </p>
        `);
      } else {
        $response.html(`
          <p>
            <b>${productNameWithoutReg}</b> does NOT contain <b>${allergenValue}</b>
          </p>
        `);
      }
    } else if ( allergenValue === 'certified kosher' || allergenValue === 'certified halal' ) {
      if ( allergenResponse ) {
        $response.html(`
          <p>
            <b>${productNameWithoutReg}</b> is <b>${allergenValue}</b>
          </p>
        `);
      } else {
        $response.html(`
          <p>
            <b>${productNameWithoutReg}</b> is NOT <b>${allergenValue}</b>
          </p>
        `);
      }
    } else if ( allergenValue === 'animal-derived products' && allergenResponse && allergenResponse.toLowerCase() !== 'yes' ) {
      $response.html(`
        <p>
          <b>${productNameWithoutReg}</b> does contain <b>${allergenValue}</b> ${allergenResponse}.
        </p>
      `);
    } else if ( ['alcohol', 'sorbitol'].includes(allergenValue) && allergenResponse && allergenResponse.toLowerCase() !== 'yes' ) {
      $response.html(`
        <p>
          <b>${productNameWithoutReg}</b> does contain <b>${allergenValue}</b>. The amount of ${allergenValue} is no more than ${allergenResponse}.
        </p>
      `);
    } else if ( allergenResponse && allergenResponse.toLowerCase() === 'yes' ) {
      $response.html(`
        <p>
          <b>${productNameWithoutReg}</b> does contain <b>${allergenValue}</b>
        </p>
      `);
    } else {
      $response.html(`
        <p>
          <b>${productNameWithoutReg}</b> does NOT contain <b>${allergenValue}</b>
        </p>
      `);
    }

    // GTM
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'allergen.submit',
      medicine: productValue,
      allergen: allergenRawValue,
    });
  });

  // Add query params
  const setQueryParam = (key, value) => {
    const url = new URL(window.location.href);

    if (value) {
      url.searchParams.set(key, value);
    } else {
      url.searchParams.delete(key);
    }

    history.replaceState(null, '', url.toString());
  };

  const isValidSelectValue = ($select, value) => {
    return $select.find(`option[value="${value}"]`).length > 0;
  };

  $product.on('change', function () {
    const selected = getSelectValue($product);
    setQueryParam('product', selected);
  });

  $allergen.on('change', function () {
    const selected = getSelectValue($allergen);
    setQueryParam('allergen', selected);
  });

  // Run on load
  const urlParams = new URLSearchParams(window.location.search);
  const productFromUrl = urlParams.get('product');
  const allergenFromUrl = urlParams.get('allergen');

  if (productFromUrl && isValidSelectValue($product, productFromUrl)) {
    $product.val(productFromUrl).trigger('change');

    const waitForAllergenOptions = setInterval(() => {
      if ($allergen.find('option').length) {
        clearInterval(waitForAllergenOptions);

        if (allergenFromUrl && isValidSelectValue($allergen, allergenFromUrl)) {
          $allergen.prop('disabled', false);
          $allergen.val(allergenFromUrl).trigger('change');

          if ($form.valid()) {
            $submitBtn.trigger('click');
          }
        }
      }
    }, 50);
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/project/allergen-checker.js